import React from 'react';
import '../hostEndedWebinar/styles.css';

// Shown on the /register page when the webinar can no longer be attended: the host
// has ended it (meetingEnded), or its scheduled end time has already passed and it
// is not live. Mirrors the hostEndedWebinar look with expiry-specific copy.
export default function WebinarExpired()
{
	return (
		<div className='flexCol aCntr hostEndedWebinarPg'>
			<div className='flexRow pdngLG'>
				<img src='/images/inmeet1.png' alt='logo' className='logo' />
			</div>
			<div className='flexMinWidthCol gap16 hostEndedWebinarBody jCntr aCntr '>
				<img src='/images/hostEndedWebinar.svg' alt='webinar expired' className='engImg' />
				<span className='mHdng textCntr'>The webinar you are trying to attend has expired.</span>
			</div>
		</div>
	);
}
